<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { getPublishedReleasesForLibrary, type PublishedReleaseForLibrary } from '@/shared/helpers/api';
    import { http } from '@/shared/httpWrapper';
    import { getCodeSetLink, getReleaseLink } from '@/shared/helpers/routing';
    import { longDate } from '@/formatters.ts';

    const props = defineProps<{
        libraryName: string;
    }>();

    const releases = ref<PublishedReleaseForLibrary[]>([]);

    onMounted(async () => {
        releases.value = await getPublishedReleasesForLibrary(http, props.libraryName);
    });
</script>

<template>
    <div>
        <h2 class="title is-4">
            Published releases
        </h2>
        <b-table
            :data="releases"
            :striped="true"
            :narrowed="true"
            :hoverable="true">
            <b-table-column
                v-slot="tableProps"
                field="dateCreated"
                label="Timestamp (UTC)"
                sortable>
                {{ longDate(tableProps.row.dateCreated) }}
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="codeSets"
                label="Code sets"
                sortable>
                <div v-if="tableProps.row.codeSets">
                    <router-link
                        v-for="cs in tableProps.row.codeSets"
                        :key="cs.name"
                        :to="getCodeSetLink(cs.name)">
                        {{ cs.description }}
                    </router-link>
                </div>
            </b-table-column>
            <b-table-column
                v-slot="tableProps"
                field="id"
                label="Release Id"
                sortable>
                <router-link :to="getReleaseLink(tableProps.row.id)">
                    {{ tableProps.row.id }}
                </router-link>
            </b-table-column>
        </b-table>
    </div>
</template>
